import SEOBreadcrumb from "@/components/feature/SEOBreadcrumb";

export default function SuperbuyAlternative() {
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: "Лучшая альтернатива SUPERBUY Spreadsheet 2026 — YOYBUY",
    url: "https://yoybuy.us/superbuy-alternative",
    datePublished: "2026-07-02",
    dateModified: "2026-07-02",
    author: { "@type": "Organization", name: "YOYBUY" },
    publisher: { "@type": "Organization", name: "YOYBUY", url: "https://yoybuy.us" },
    description: "YOYBUY Spreadsheet — лучшая альтернатива SUPERBUY в 2026 году. Ниже комиссия, быстрее обработка, полная прозрачность.",
  };

  const reasons = [
    {
      icon: "ri-money-dollar-circle-line",
      title: "Комиссия 3–5% вместо 10–15%",
      desc: "YOYBUY Spreadsheet работает с минимальной наценкой за счет автоматизации. SUPERBUY закладывает в цену расходы на маркетинг и бренд — и вы платите за это из своего кармана.",
    },
    {
      icon: "ri-time-line",
      title: "Обработка за 6–12 часов вместо 24–48",
      desc: "Spreadsheet YOYBUY напрямую поступает исполнителю без промежуточных менеджеров. Это сокращает время обработки в 3–4 раза по сравнению с SUPERBUY.",
    },
    {
      icon: "ri-eye-line",
      title: "Полная прозрачность каждой копейки",
      desc: "Вы видите оригинальный чек от поставщика, реальный вес до грамма, стоимость каждого этапа. SUPERBUY показывает только итоговую сумму без детализации.",
    },
    {
      icon: "ri-weight-line",
      title: "Вес до грамма, а не округление до 100 г",
      desc: "SUPERBUY округляет вес посылки в большую сторону. YOYBUY считает до грамма — экономия $5–10 с каждой отправки.",
    },
    {
      icon: "ri-archive-line",
      title: "30 дней бесплатного хранения вместо 7",
      desc: "Вы можете накопить товары на складе YOYBUY и отправить одной посылкой, сэкономив на доставке. SUPERBUY начинает брать плату за хранение уже через неделю.",
    },
    {
      icon: "ri-camera-line",
      title: "Бесплатный фотоотчет, а не платный пакет",
      desc: "В YOYBUY Spreadsheet фотоотчет включен в стоимость обработки. В SUPERBUY за фото нужно платить отдельно — $2–5 за позицию.",
    },
  ];

  return (
    <article className="bg-background-50 min-h-screen pt-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <div className="relative w-full h-[280px] md:h-[380px]">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20a%20single%20laptop%20showing%20a%20bright%20spreadsheet%20interface%20in%20warm%20green%20and%20coral%20tones%2C%20fresh%20airy%20atmosphere%2C%20cream%20tones%2C%20small%20potted%20plant%20and%20natural%20light%20streaming%20through%20window%2C%20minimalist%20productive%20setup%2C%20editorial%20interior%20photography%2C%20soft%20shadows%2C%20no%20text&width=1200&height=600&seq=superbuy-alternative-header&orientation=landscape"
          alt="Альтернатива SUPERBUY — YOYBUY Spreadsheet"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          width={1200}
          height={600}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35" />
        <div className="absolute inset-0 flex items-end">
          <div className="w-full px-4 md:px-8 pb-8 md:pb-12 max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-4xl font-bold text-white font-heading leading-tight">
              Лучшая альтернатива SUPERBUY Spreadsheet в 2026 году — YOYBUY
            </h1>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-8 md:py-12 max-w-3xl mx-auto">
        <SEOBreadcrumb
          items={[
            { label: "Главная", href: "/" },
            { label: "Альтернатива SUPERBUY" },
          ]}
        />

        <div className="prose prose-stone max-w-none">
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
            Если вы пользуетесь SUPERBUY и чувствуете, что комиссии слишком высоки, а прозрачности недостаточно — вы не одиноки. Тысячи покупателей из Китая ищут альтернативу SUPERBUY в 2026 году, и <strong>YOYBUY Spreadsheet</strong> стал выбором №1. Ниже — 6 конкретных причин, почему.
          </p>

          <div className="bg-background-100 rounded-lg p-5 md:p-6 my-8">
            <p className="text-foreground-600 text-sm leading-relaxed">
              Сравнения: <a href="/yoybuy-vs-superbuy" className="text-primary-600 hover:text-primary-700 underline">YOYBUY vs SUPERBUY</a> | <a href="/yoybuy-vs-kakobuy" className="text-primary-600 hover:text-primary-700 underline">YOYBUY vs KAKOBUY</a> | <a href="/kakobuy-vs-superbuy" className="text-primary-600 hover:text-primary-700 underline">KAKOBUY vs SUPERBUY</a>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-10">
            {reasons.map((item) => (
              <div key={item.title} className="bg-white border border-background-200 rounded-lg p-6 transition-colors hover:border-primary-300">
                <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4">
                  <i className={`${item.icon} text-xl`} />
                </div>
                <h4 className="font-heading font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          <h4 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mt-10 mb-4">
            <a href="#migration" id="migration">Как перейти с SUPERBUY на YOYBUY Spreadsheet за 10 минут</a>
          </h4>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            Переход с SUPERBUY на YOYBUY Spreadsheet проще, чем кажется:
          </p>
          <ol className="space-y-4 mb-6 list-decimal pl-5">
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">
              <strong>Создайте аккаунт</strong> на <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline">kaspreadsheet.com</a> — это займет 2 минуты.
            </li>
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">
              <strong>Выберите категорию</strong> на <a href="/" className="text-primary-600 hover:text-primary-700 underline">главной странице YOYBUY</a> и начните с одного тестового заказа.
            </li>
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">
              <strong>Сравните итоговую цену</strong> с тем, что вы заплатили бы в SUPERBUY за аналогичный заказ. Разница обычно видна сразу.
            </li>
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">
              <strong>Перенесите активные заказы.</strong> Если у вас есть товары на складе SUPERBUY, их можно отправить на новый адрес — команда YOYBUY поможет с логистикой.
            </li>
          </ol>

          <div className="bg-accent-50 border border-accent-200 rounded-lg p-5 md:p-6 my-8">
            <p className="text-accent-900 text-sm md:text-base font-medium mb-3">
              Готовы попробовать альтернативу SUPERBUY?
            </p>
            <p className="text-accent-800 text-sm leading-relaxed mb-4">
              Сделайте первый заказ через YOYBUY Spreadsheet и убедитесь в разнице. Средняя экономия на первом заказе — $30–50.
            </p>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-block bg-accent-500 hover:bg-accent-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors">
              Попробовать YOYBUY Spreadsheet
            </a>
          </div>

          <h4 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mt-10 mb-4">
            <a href="#testimonials" id="testimonials">Реальные результаты перехода с SUPERBUY на YOYBUY</a>
          </h4>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
            Пользователи, которые сменили SUPERBUY на YOYBUY Spreadsheet в 2025–2026 годах, отмечают:
          </p>
          <ul className="space-y-3 mb-6 list-disc pl-5">
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">Экономия $150–300 в месяц при volume-закупках одежды и обуви.</li>
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">Сокращение времени обработки заказа с 2–3 дней до нескольких часов.</li>
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">Отсутствие «сюрпризов» в итоговом чеке — все цифры известны upfront.</li>
            <li className="text-foreground-700 text-sm md:text-base leading-relaxed">Бесплатная консолидация посылок, которая в SUPERBUY стоила $5–10.</li>
          </ul>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
            <a href="/faq" className="text-primary-600 hover:text-primary-700 underline">Часто задаваемые вопросы</a> помогут развеять оставшиеся сомнения. А <a href="/" className="text-primary-600 hover:text-primary-700 underline">главная страница</a> покажет полную картину возможностей YOYBUY Spreadsheet.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-6 border-t border-background-200">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-block bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors text-center">
              yoybuy sheet
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="inline-block bg-accent-500 hover:bg-accent-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors text-center">
              buy it now
            </a>
            <a href="/" className="inline-block bg-white border border-background-200 hover:border-primary-400 text-foreground-900 font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors text-center">
              Вернуться на главную
            </a>
          </div>
        </div>
      </div>
    </article>
  );
}